import * as QueryString from 'query-string'
import { APIConfig} from '../types';

export default class APIBase {
        /**
         *  url for the API
         */
         public readonly apiUrl: string
         /**
          * Logger function to use when debugging
          */
         public logger: (arg: string) => void
     
         protected apiKey: string | undefined
     
         /**
          * @param config APIConfig for setting up the API
          * @param logger Optional function for logging debug strings before and after requests are made
          */
         constructor(config?: APIConfig, logger?: (arg: string) => void) {
             this.apiKey = config?.apiKey || process.env.REACT_APP_API_KEY
             this.apiUrl = config?.apiUrl || ''
     
             // Debugging: default to nothing
             this.logger = logger || ((arg: string) => arg)
         }
         
    /**
   * Get JSON data from API, sending auth token in headers
   * @param apiPath Path to URL endpoint under API
   * @param query Data to send. Will be stringified using QueryString
   */
     public async get(apiPath: string, query: object = {}, headers = {}, array=false): Promise<any> {
        let fullHeaders = {
            ...{
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            ...headers
        }
        console.log("object-query", query, "api", apiPath)
        const qs = array? QueryString.stringify(query,{arrayFormat: 'bracket'}): QueryString.stringify(query)
        console.log("querry-string", qs)
        const url = `${apiPath}?${qs}`
        
        const fetchOpts = {
            method: 'GET',
            headers: fullHeaders,
        }
        const response = await this._fetch(url, fetchOpts)
        return response.json()
    }

    /**
     * POST JSON data to API, sending auth token in headers
     * @param apiPath Path to URL endpoint under API
     * @param body Data to send. Will be JSON.stringified
     * @param opts RequestInit opts, similar to Fetch API. If it contains
     *  a body, it won't be stringified.
     */
    public async post(apiPath: string, body?: object, opts: RequestInit = {}, headers = {}): Promise<any> {
        let fullHeaders = {
            ...{
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            ...headers
        }
        const fetchOpts = {
            method: 'POST',
            body: body ? JSON.stringify(body) : undefined,
            headers: fullHeaders,
            ...opts
        }

        const response = await this._fetch(apiPath, fetchOpts)
        return response.json()
    }

    public async postFile(apiPath: string, body?: FormData, opts: RequestInit = {}, headers = {}): Promise<any> {
        let fullHeaders = {
            ...{
                Accept: 'multipart/form-data',
            },
            ...headers
        }
        const fetchOpts = {
            method: 'POST',
            body: body ? body : undefined,
            headers: fullHeaders,
            ...opts
        }

        const response = await this._fetch(apiPath, fetchOpts)
        return response.json()
    }

    /**
     * PUT JSON data to API, sending auth token in headers
     * @param apiPath Path to URL endpoint under API
     * @param opts RequestInit opts, similar to Fetch API. If it contains
     *  a body, it won't be stringified.
     */
    public async delete(apiPath: string, opts: RequestInit = {}, headers = {}) {

        let fullHeaders = {
            ...{
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            ...headers
        }
        const fetchOpts = {
            method: 'DELETE',
            headers: fullHeaders,
            ...opts
        }

        const response = await this._fetch(apiPath, fetchOpts)
        return response.json()
    }


    /**
     * PUT JSON data to API, sending auth token in headers
     * @param apiPath Path to URL endpoint under API
     * @param body Data to send
     * @param opts RequestInit opts, similar to Fetch API. If it contains
     *  a body, it won't be stringified.
     */
     public async put(apiPath: string, body: object, opts: RequestInit = {}, headers = {}) {
        let fullHeaders = {
            ...{
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            ...headers
        }
        const fetchOpts = {
            method: 'PUT',
            body: body ? JSON.stringify(body) : undefined,
            headers: fullHeaders,
            ...opts
        }

        const response = await this._fetch(apiPath, fetchOpts)
        return response.json()
    }


    /**
     * Get from an API Endpoint, sending auth token in headers
     * @param apiPath Path to URL endpoint under API
     * @param opts RequestInit opts, similar to Fetch API
     */
     private async _fetch(apiPath: string, opts: RequestInit = {}) {
        const apiKey = this.apiKey
        const finalUrl = this.apiUrl + apiPath
        const finalOpts = {
            ...opts,
            headers: {
                ...(apiKey ? { 'X-API-KEY': apiKey } : {}),
                ...(opts.headers || {}),
            },
        }

        this.logger(`Sending request: ${finalUrl} ${JSON.stringify(finalOpts).substr(0, 100)}...`)

        return fetch(finalUrl, finalOpts,).then(async res => this._handleApiResponse(res))
    }

    private async _handleApiResponse(response: Response) {
        if (response.ok) {
            this.logger(`Got success: ${response.status}`)
            return response
        }

        let result:any
        let errorMessage
        try {
            result = await response.text()
            result = JSON.parse(result)
        } catch {
            // Result will be undefined or text
        }

        this.logger(`Got error ${response.status}: ${JSON.stringify(result)}`)

        switch (response.status) {
            case 400:
                errorMessage = result && result.errors
                    ? result.errors.join(', ')
                    : `Invalid request: ${JSON.stringify(result.error.message)}`
                break
            case 401:
            case 403:
                errorMessage = `Unauthorized.'${JSON.stringify(result)}'`
                break
            case 404:
                errorMessage = `Not found.'${JSON.stringify(result)}'`
                break
            case 500:
                errorMessage = `${JSON.stringify(result!.error.message)}`
                break
            case 503:
                errorMessage = `${JSON.stringify(result)}`
                break
            default:
                errorMessage = `Message: ${JSON.stringify(result)}`
                break
        }

        throw new Error(`${errorMessage}`)
    }
}

